import React from 'react'
import {Calendar, MapPin, Clock, Users} from 'lucide-react'
import { motion } from 'framer-motion'

const Events: React.FC = () => {
  // Mock data
  const upcomingEvents = [
    {
      id: '1',
      title: 'Culto de Celebração',
      date: '28/01/2024',
      time: '18h00',
      location: 'Sede do Ministério',
      description: 'Um momento especial de louvor, adoração e ministração da Palavra.',
      image: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=600&h=400&fit=crop',
      attendees: 150
    },
    {
      id: '2',
      title: 'Retiro Espiritual',
      date: '10/02/2024',
      time: '08h00',
      location: 'Chácara Betânia',
      description: 'Dois dias de renovação espiritual, jejum e oração.',
      image: 'https://images.unsplash.com/photo-1510022079733-8b58aca7c4a9?w=600&h=400&fit=crop',
      attendees: 80
    }
  ]

  const pastEvents = [
    {
      id: '3',
      title: 'Conferência da Família',
      date: '15/01/2024',
      image: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=600&h=400&fit=crop',
      description: 'Fortalecendo os laços familiares através da Palavra.'
    }
  ]

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#1e3a8a] to-[#6b8f71] py-20">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl font-bold text-white mb-6">
              Eventos
            </h1>
            <p className="text-xl text-white/90">
              Participe dos nossos encontros e celebrações
            </p>
          </motion.div>
        </div>
      </section>

      {/* Próximos Eventos */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-12">
            Próximos Eventos
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {upcomingEvents.map((event, index) => (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all overflow-hidden"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={event.image} 
                    alt={event.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-white px-4 py-2 rounded-lg shadow-lg">
                    <p className="text-3xl font-bold text-[#1e3a8a]">
                      {event.date.split('/')[0]}
                    </p>
                    <p className="text-sm text-gray-600">
                      {event.date.split('/')[1]}/{event.date.split('/')[2]}
                    </p>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-[#1e3a8a] mb-4">
                    {event.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {event.description}
                  </p>
                  <div className="space-y-2 mb-6">
                    <div className="flex items-center gap-2 text-gray-700">
                      <Clock size={18} className="text-[#6b8f71]" />
                      {event.time}
                    </div>
                    <div className="flex items-center gap-2 text-gray-700">
                      <MapPin size={18} className="text-[#6b8f71]" />
                      {event.location}
                    </div>
                    <div className="flex items-center gap-2 text-gray-700">
                      <Users size={18} className="text-[#6b8f71]" />
                      {event.attendees} confirmados
                    </div>
                  </div>
                  <button className="w-full bg-[#6b8f71] text-white py-3 rounded-lg font-semibold hover:bg-[#5a7760] transition-all">
                    Confirmar Presença
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Eventos Passados */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-12">
            Galeria de Eventos
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {pastEvents.map((event, index) => (
              <motion.div
                key={event.id}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all overflow-hidden cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={event.image} 
                    alt={event.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-4">
                  <p className="text-sm text-gray-500 mb-1">{event.date}</p>
                  <h3 className="text-lg font-bold text-[#1e3a8a]">
                    {event.title}
                  </h3>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Events
